import type React from 'react';

import { MenuItem } from '@mui/material';

import { type Option } from 'components/panels/eventsSplitDraws/selectedEvent/rankingsAndRatings/types';
import TMXSelect, { type MuiSelectProps } from 'components/selectors/tmxSelector/TMXSelect';

type ListTypeSelectProps = MuiSelectProps & {
  options?: Option[];
};

const ListTypeSelect: React.FC<React.PropsWithChildren<ListTypeSelectProps>> = ({ options, field, form, ...props }) => (
  <TMXSelect
    displayEmpty
    fullWidth
    value={field?.value ? field?.value : props.value}
    onChange={
      field?.onChange
        ? (value) => {
            return form.setFieldValue(field.name, value, false);
          }
        : props.onChange
    }
    {...props}
  >
    {(options || []).map((o) => (
      <MenuItem key={o.value} value={o.value}>
        {o.label}
      </MenuItem>
    ))}
  </TMXSelect>
);

export default ListTypeSelect;
